import { makeStyles } from '@material-ui/core/styles';

export const useReadDefectiveTagsStepStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(6),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3)
  },
  info: {
    display: 'flex',
    flexDirection: 'row',
    '& .MuiCollapse-root': {
      flex: 1
    }
  },
  infoIcon: {
    marginRight: theme.spacing(1),
    color: '#a5c2d9'
  },
  title: {
    fontWeight: theme.font.weight.bold
  },
  summary: {
    marginBottom: '1rem',
    alignItems: 'center',
    flex: 1
  },
  loadingContainer: {
    justifyItems: 'center',
    marginTop: theme.spacing(3)
  },
  loading: {
    height: '3rem'
  }
}));
